import { Container, Stack, Typography } from '@mui/material'
import { ContactForm } from './ContactForm'

/** Asks an account created by SMS, before email became mandatory, for its email. */
export function EmailRequired() {
  return (
    <Container maxWidth="xs" sx={{ py: 6 }}>
      <Stack spacing={2}>
        <Typography variant="h4" component="h1">
          Ajoutez votre email
        </Typography>
        <Typography color="text.secondary">
          Chaque compte a maintenant une adresse email : c'est par elle que vous recevez les
          invitations et que vous vous connectez. Le SMS reste possible pour vous reconnecter.
        </Typography>
        <ContactForm kind="email" />
      </Stack>
    </Container>
  )
}
